/* eslint-disable consistent-return */
import { Button, Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import EmailIcon from '@material-ui/icons/Email';
import { getClassrommsById, inviteStudentSchool } from '@webapps/business';
import {
  FormikAutocomplete,
  TextField,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const inviteStudentSchema = yup.object().shape({
  students: yup.array(),
  type: yup.string(),
  groupId: yup.string().required('Requis'),
});

const InviteStudents = ({ close }) => {
  const {
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const {
    data: { content: classrooms = [] } = {},
    isLoading: classroomsLoading,
  } = useQuery(getClassrommsById, {
    key: 'classroom',
    variables: { id: idUser },
  });

  const {
    isLoading,
    isSuccess,
    mutate: mutateInviteStudent,
  } = useMutation(inviteStudentSchool);

  const { addToast } = useToast();

  const [errorEmail, setErrorEmail] = useState(false);
  const [errorEmailExist, setErrorEmailExist] = useState(false);
  const [email, setEmail] = useState('');
  const [listEmail, setListEmail] = useState([]);

  const handleChangeEmail = (labelEmail) => {
    const re = /\S+@\S+\.\S+/;
    setErrorEmail(false);
    setErrorEmailExist(false);
    if (re.test(labelEmail)) {
      setEmail(labelEmail);
      return true;
    }
    setErrorEmail(true);
    return false;
  };

  const addToListEmail = () => {
    const newEmails = email.split(';').map((e) => e.trim()).filter(Boolean);
    let emailAlreadyExists = false;
    let newEmailsList = [];

    newEmails.forEach((newEmail) => {
      if (handleChangeEmail(newEmail) && !listEmail.includes(newEmail)) {
        newEmailsList = [...newEmailsList, newEmail];
      } else {
        emailAlreadyExists = true;
      }
    });

    if (emailAlreadyExists) {
      setErrorEmailExist(true);
    } else {
      setListEmail([...listEmail, ...newEmailsList]);
      setEmail('');
    }
  };

  const removeEmailToList = (labelToDelete) => {
    const newList = listEmail.filter((item) => item !== labelToDelete);
    setListEmail(newList);
  };

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Invitation(s) envoyé(s)',
      });
      close();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      students: listEmail,
      groupId: '',
      type: 'join_classroom',
    },
    validationSchema: inviteStudentSchema,
    onSubmit: async ({ groupId }) => {
      await mutateInviteStudent({
        data: {
          students: listEmail,
          groupId,
          type: 'join_classroom',
        },
      });
    },
  });


  return (
    <div>
      <Grid className={css({ marginTop: spacing(1) })} container spacing={2}>
        <Grid item xs={12}>
          <FormikAutocomplete
            formik={formik}
            variant='outlined'
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => value.id === option.id}
            label="Sélectionner une classe"
            loading={classroomsLoading}
            borderRadius={6}
            loadingText={
              <>
                <FormattedMessage id="loading" />
                ...
              </>
            }
            name="groupId"
            options={classrooms}
            pathValue="id"
            value={
              classrooms.find(({ id }) => id === formik.values.groupId) || null
            }
          />
        </Grid>
        <div className={css({ fontSize: '13.5000px', marginLeft: '12px' })}>Si vous souhaitez ajouter plusieurs mails à la fois, suivez ce format : </div>
        <div className={css({ fontSize: '13.5000px', marginLeft: '12px' })}>mail@gmail.com; mail2@gmail.com; mail3@gmail.com; ...</div>
        <Grid
          className={css({
            marginTop: spacing(0),
            display: 'flex',
            flexDirection: 'row',
            '@media (max-width:768px)': { flexDirection: 'column' }
          })}
          item
          xs={12}
        >
          <TextField
            className={css({ '@media (min-width:768px)': { marginRight: spacing(1) } })}
            fullWidth
            label="Taper une adresse mail"
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            type="email"
            variant='outlined'
            value={email}
          />
          <Button
            type='button'
            className={css({ marginLeft: spacing(1), border: '1px solid #0060F9', fontWeight: 600, '&:hover': { border: '1px solid #0060F9' }, '@media (max-width:768px)': { marginLeft: 0, marginTop: spacing(1) } })}
            color="primary"
            onClick={addToListEmail}
            variant="outlined"
          >
            Ajouter
          </Button>
        </Grid>
        {errorEmail && (
          <Grid
            className={css({
              display: 'flex',
              marginTop: spacing(0),
              color: 'red',
            })}
            item
            xs={12}
          >
            <div>Veuillez saisir un e-mail valide svp!</div>
          </Grid>
        )}
        {errorEmailExist && (
          <Grid
            className={css({
              display: 'flex',
              marginTop: spacing(0),
              color: 'red',
            })}
            item
            xs={12}
          >
            <div>E-mail déja renseigné!</div>
          </Grid>
        )}
        {listEmail.length > 0 && (
          <Grid
            className={css({
              marginTop: spacing(0),
              maxHeight: 250,
              overflow: 'auto',
            })}
            item
            xs={12}
          >
            {listEmail.map((item, index) => (
              <div
                key={index}
                className={css({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                })}
              >
                <div className={global.infoText}>{item}</div>
                <div>
                  <IconButton
                    color="secondary"
                    onClick={() => removeEmailToList(item)}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            ))}
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2}>
        <Grid className={css({ textAlign: 'center' })} item xs>
          <Button
            className={css({ borderRadius: '400px' })}
            color="primary"
            disabled={isLoading}
            onClick={formik.handleSubmit}
            variant="contained"
          >
            Envoyer
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

InviteStudents.propTypes = {
  close: PropTypes.func,
};

export default InviteStudents;
